// extracted by mini-css-extract-plugin
export default {"plate":"VehicleNumber_plate__w97hm","region":"VehicleNumber_region__DuyVX","number":"VehicleNumber_number__fUyU+","flag":"VehicleNumber_flag__VUimY"};